// /var/www/oszczedzam/client/src/components/budgets/BudgetCard.js
import React from 'react';
import { 
  Box, Card, CardContent, Typography, LinearProgress, 
  IconButton, Tooltip, Menu, MenuItem, ListItemIcon, ListItemText
} from '@mui/material';
import { 
  MoreVert as MoreIcon, 
  Edit as EditIcon, 
  Delete as DeleteIcon 
} from '@mui/icons-material';

function BudgetCard({ budget, spent, onEdit, onDelete }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  
  // Oblicz procent wykorzystania budżetu
  const percentUsed = spent ? Math.min(Math.round((spent / budget.limit) * 100), 100) : 0;
  
  // Określ kolor paska postępu na podstawie procentu wykorzystania
  const getProgressColor = (percent) => {
    if (percent >= 90) return 'error';
    if (percent >= 70) return 'warning';
    return 'success';
  };
  
  // Formatuj kwotę
  const formatAmount = (amount) => {
    return amount.toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' });
  };
  
  // Formatuj okres
  const formatPeriod = (period) => {
    switch (period) {
      case 'monthly': return 'miesięcznie';
      case 'weekly': return 'tygodniowo';
      case 'yearly': return 'rocznie';
      default: return period;
    }
  };
  
  // Obsługa menu
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  
  const handleEditClick = () => {
    handleCloseMenu();
    onEdit(budget);
  };
  
  const handleDeleteClick = () => {
    handleCloseMenu();
    onDelete(budget.id);
  };

  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Typography variant="h6" component="div">
            {budget.category}
          </Typography>
          <IconButton onClick={handleOpenMenu} size="small">
            <MoreIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
          >
            <MenuItem onClick={handleEditClick}>
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Edytuj</ListItemText>
            </MenuItem>
            <MenuItem onClick={handleDeleteClick}>
              <ListItemIcon>
                <DeleteIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Usuń</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
        
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Limit: {formatAmount(budget.limit)} {formatPeriod(budget.period)}
        </Typography>
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="body2">
            Wykorzystano: {formatAmount(spent || 0)} ({percentUsed}%)
          </Typography>
          <Typography variant="body2">
            Pozostało: {formatAmount(Math.max(budget.limit - (spent || 0), 0))}
          </Typography>
        </Box>
        
        <LinearProgress 
          variant="determinate" 
          value={percentUsed} 
          color={getProgressColor(percentUsed)} 
          sx={{ height: 8, borderRadius: 4 }}
        />
      </CardContent>
    </Card>
  );
}

export default BudgetCard;